import React, { HTMLAttributes, useEffect, useRef } from "react";
import { Simulate } from "react-dom/test-utils";
import drag = Simulate.drag;

interface IProps extends HTMLAttributes<HTMLDivElement> {

}

export function CustomTouchScroll({ children, ...props }: IProps) {
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!ref.current) return;
        const div = ref.current;

        const handlePointerDown = (e: PointerEvent) => {
            const startScrollTop = div.scrollTop;
            const startY = e.clientY;

            const handlePointerMove = (e: PointerEvent) => {
                const distance = startScrollTop + ((e.clientY - startY) * -1);
                div.scroll(0, distance);
            }
            const handlePointerUp = () => {
                window.removeEventListener('pointermove', handlePointerMove);
                window.removeEventListener('pointerup', handlePointerUp);
            }
            window.addEventListener('pointermove', handlePointerMove);
            window.addEventListener('pointerup', handlePointerUp);
        }
        div.addEventListener('pointerdown', handlePointerDown);
        return () => {
            div.removeEventListener('pointerdown', handlePointerDown);
        }
    }, [ref]);

    return (
        <div ref={ref} {...props}>
            {children}
        </div>
    )
}
